export function downloadFile(objectUrl, fileName) {
    const a = document.createElement('a');
    a.setAttribute('style', 'display: none');
    document.body.appendChild(a);
    a.href = objectUrl;
    a.download = fileName;
    a.click();
}
export function downloadLegacyFile(file, fileName) {
    if (!file.url) {
        return;
    }
    downloadFile(file.url, fileName);
}
